// src/components/common/LoadingOverlay.js
import React from 'react';
import { Box, CircularProgress, Typography, alpha, useTheme } from '@mui/material';

/**
 * A non-blocking loading overlay that always renders children
 * and optionally shows a loading indicator in the corner
 * 
 * @param {Object} props Component props
 * @param {string} [props.message='Loading...'] The message to display
 * @param {boolean} [props.loading=false] Whether to show the loading indicator
 * @param {React.ReactNode} props.children Content to render
 */
const LoadingOverlay = ({ message = 'Loading...', loading = false, children }) => {
  const theme = useTheme();
  
  // Always render children
  return (
    <Box position="relative">
      {children}
      
      {loading && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            m: 3,
            p: 1.5,
            borderRadius: 2,
            display: 'flex',
            alignItems: 'center',
            backgroundColor: alpha(theme.palette.background.paper, 0.8),
            backdropFilter: 'blur(4px)',
            boxShadow: `0 4px 12px ${alpha(theme.palette.common.black, 0.15)}`,
            zIndex: 1200,
          }}
        >
          <CircularProgress size={24} thickness={4} sx={{ mr: 1.5 }} />
          <Typography variant="body2" fontWeight="medium">
            {message}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default LoadingOverlay;